import * as React from "react";
import { forwardRef } from "react";
const SvgDash = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={13} height={2} viewBox="0 0 13 2" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M13 0.438965V1.45459H0V0.438965H13Z" fill="#8E979F" /></svg>;
const ForwardRef = forwardRef(SvgDash);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDEzIDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTMgMC40Mzg5NjVWMS40NTQ1OUgwVjAuNDM4OTY1SDEzWiIgZmlsbD0iIzhFOTc5RiIvPgo8L3N2Zz4=";